const textFieldProps = {
  borderRadius: "5px",
};

export default textFieldProps;
